import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../app/hooks";
import {
	clearDistrict,
	setDistrict,
	setDistricts,
	transitionDistrict,
} from "../../../app/userSlice";
import NamedEntity from "../../../interfaces/NamedEntity";
import {
	useMakeDistrictSelectionMutation,
	useGetDistrictPickerOptionsQuery,
} from "../../districts/districtsApiSlice";
import Picker from "./Picker";

export default function DistrictPicker() {
	const { district } = useAppSelector((state) => state.user);
	const selectDistrictsURL = "/selectDistrict";

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [callSelectDistrict] = useMakeDistrictSelectionMutation();
	const districts = useGetDistrictPickerOptionsQuery().data;

	useEffect(() => {
		if (districts) dispatch(setDistricts(districts));
	}, [districts]);

	function handleSelectDistrict(district: NamedEntity) {
		dispatch(transitionDistrict());
		callSelectDistrict(district.id)
			.unwrap()
			.then(() => {
				dispatch(
					setDistrict({
						id: district.id,
						name: district.name,
					})
				);
				navigate("/adminHome");
			})
			.catch((error) => {
				dispatch(clearDistrict());
				navigate(selectDistrictsURL);
			});
	}

	if (!districts || !district) return null;

	return (
		<Picker
			currentOption={district}
			options={districts}
			label={"districts"}
			navigateURL={selectDistrictsURL}
			onClick={handleSelectDistrict}
		/>
	);
}
